import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function CreerCompte() {
  const [form, setForm] = useState({
    nom: '', prenom: '', email: '', telephone: '', entreprise: '', role: 'client',
  });
  const [loading, setLoading] = useState(false);
  const [succes, setSucces] = useState('');
  const [erreur, setErreur] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSucces('');
    setErreur('');

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://efe-systems.com/api/admin/creer-compte',
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSucces(`Compte créé ! Mot de passe temporaire : ${response.data.mot_de_passe}`);
      setForm({ nom: '', prenom: '', email: '', telephone: '', entreprise: '', role: 'client' });
    } catch (error) {
      setErreur(error.response?.data?.message || 'Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    background: '#f8f9ff',
    border: '1px solid rgba(26,26,230,0.15)',
    color: '#0F0F2D',
    borderRadius: '12px',
    padding: '12px 16px',
    width: '100%',
    outline: 'none',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  return (
    <div className="max-w-2xl">
      <div className="rounded-3xl p-8 bg-white"
        style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 4px 30px rgba(0,0,0,0.08)' }}>

        <h2 className="text-2xl font-extrabold mb-2" style={{ color: '#0F0F2D' }}>
          Créer un compte client
        </h2>
        <p className="text-gray-400 text-sm mb-6">
          Un mot de passe temporaire sera généré et envoyé par email au client.
        </p>

        {succes && (
          <div className="mb-4 px-4 py-3 rounded-xl text-sm"
            style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', color: '#10B981' }}>
            ✅ {succes}
          </div>
        )}

        {erreur && (
          <div className="mb-4 px-4 py-3 rounded-xl text-sm"
            style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#EF4444' }}>
            ❌ {erreur}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-gray-500 text-xs mb-1 block">Prénom *</label>
              <input name="prenom" value={form.prenom} onChange={handleChange}
                placeholder="Jean" required style={inputStyle} />
            </div>
            <div>
              <label className="text-gray-500 text-xs mb-1 block">Nom *</label>
              <input name="nom" value={form.nom} onChange={handleChange}
                placeholder="Pierre" required style={inputStyle} />
            </div>
          </div>
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Email *</label>
            <input name="email" type="email" value={form.email} onChange={handleChange}
              placeholder="jean@exemple.com" required style={inputStyle} />
          </div>
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Téléphone</label>
            <input name="telephone" value={form.telephone} onChange={handleChange}
              placeholder="+509 XXXX XXXX" style={inputStyle} />
          </div>
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Organisation / Entreprise</label>
            <input name="entreprise" value={form.entreprise} onChange={handleChange}
              placeholder="Nom de l'organisation" style={inputStyle} />
          </div>
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Rôle</label>
          <select name="role" value={form.role} onChange={handleChange}
  style={{ ...inputStyle, cursor: 'pointer' }}>
  <option value="client">Client</option>
  <option value="technicien">Technicien / Ingénieur</option>
  <option value="coordinateur">Coordinateur</option>
  <option value="admin">Admin</option>
</select>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-xl font-semibold text-lg transition hover:opacity-90"
            style={{ background: '#1A1AE6', color: 'white', border: 'none', cursor: loading ? 'not-allowed' : 'pointer', boxShadow: '0 4px 15px rgba(26,26,230,0.3)' }}
          >
            {loading ? 'Création en cours...' : 'Créer le compte →'}
          </button>
        </form>
      </div>
    </div>
  );
}

function CreerProjet() {
  const [form, setForm] = useState({
    client_id: '',
    titre: '',
    description: '',
    service_id: '',
    montant_total: '',
    date_debut: '',
    date_livraison_prevue: '',
    notes_client: '',
  });
  const [users, setUsers] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [succes, setSucces] = useState('');
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    chargerDonnees();
  }, []);

  const chargerDonnees = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const [usersRes, servicesRes] = await Promise.all([
        axios.get('https://efe-systems.com/api/admin/users', { headers }),
        axios.get('https://efe-systems.com/api/services'),
      ]);
      setUsers(usersRes.data);
      setServices(servicesRes.data);
    } catch (error) {
      console.error('Erreur chargerDonnees:', error.response?.status, error.response?.data);
    }
  };
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSucces('');
    setErreur('');

    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'https://efe-systems.com/api/projets',
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSucces('Projet créé avec succès !');
      setForm({
        client_id: '', titre: '', description: '', service_id: '',
        montant_total: '', date_debut: '', date_livraison_prevue: '', notes_client: '',
      });
    } catch (error) {
      setErreur(error.response?.data?.message || 'Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    background: '#f8f9ff',
    border: '1px solid rgba(26,26,230,0.15)',
    color: '#0F0F2D',
    borderRadius: '12px',
    padding: '12px 16px',
    width: '100%',
    outline: 'none',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  const clients = users.filter(u => u.role === 'client');

  return (
    <div className="max-w-2xl">
      <div className="rounded-3xl p-8 bg-white"
        style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 4px 30px rgba(0,0,0,0.08)' }}>

        <h2 className="text-2xl font-extrabold mb-2" style={{ color: '#0F0F2D' }}>
          Créer un projet
        </h2>
        <p className="text-gray-400 text-sm mb-6">
          Associez un projet à un client et définissez les détails.
        </p>

        {succes && (
          <div className="mb-4 px-4 py-3 rounded-xl text-sm"
            style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', color: '#10B981' }}>
            ✅ {succes}
          </div>
        )}

        {erreur && (
          <div className="mb-4 px-4 py-3 rounded-xl text-sm"
            style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#EF4444' }}>
            ❌ {erreur}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">

          {/* Client */}
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Client *</label>
            <select name="client_id" value={form.client_id} onChange={handleChange}
              required style={{ ...inputStyle, cursor: 'pointer' }}>
              <option value="">Sélectionner un client</option>
              {clients.map(c => (
                <option key={c.id} value={c.id}>
                  {c.prenom} {c.nom} — {c.email}
                </option>
              ))}
            </select>
          </div>

          {/* Titre */}
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Titre du projet *</label>
            <input name="titre" value={form.titre} onChange={handleChange}
              placeholder="Ex: Site web EFE Systems" required style={inputStyle} />
          </div>

          {/* Description */}
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Description *</label>
            <textarea name="description" value={form.description} onChange={handleChange}
              placeholder="Décrivez le projet..." required rows={3}
              style={{ ...inputStyle, resize: 'none' }} />
          </div>

          {/* Service */}
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Service *</label>
            <select name="service_id" value={form.service_id} onChange={handleChange}
              required style={{ ...inputStyle, cursor: 'pointer' }}>
              <option value="">Sélectionner un service</option>
              {services.map(s => (
                <option key={s.id} value={s.id}>{s.nom}</option>
              ))}
            </select>
          </div>

          {/* Montant */}
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Montant total ($)</label>
            <input name="montant_total" type="number" value={form.montant_total} onChange={handleChange}
              placeholder="Ex: 5000" style={inputStyle} />
          </div>

          {/* Dates */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-gray-500 text-xs mb-1 block">Date de début</label>
              <input name="date_debut" type="date" value={form.date_debut} onChange={handleChange}
                style={{ ...inputStyle, colorScheme: 'light' }} />
            </div>
            <div>
              <label className="text-gray-500 text-xs mb-1 block">Date de livraison prévue</label>
              <input name="date_livraison_prevue" type="date" value={form.date_livraison_prevue} onChange={handleChange}
                style={{ ...inputStyle, colorScheme: 'light' }} />
            </div>
          </div>

          {/* Notes client */}
          <div>
            <label className="text-gray-500 text-xs mb-1 block">Notes pour le client</label>
            <textarea name="notes_client" value={form.notes_client} onChange={handleChange}
              placeholder="Message visible par le client..." rows={3}
              style={{ ...inputStyle, resize: 'none' }} />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-xl font-semibold text-lg transition hover:opacity-90"
            style={{ background: '#1A1AE6', color: 'white', border: 'none', cursor: loading ? 'not-allowed' : 'pointer', boxShadow: '0 4px 15px rgba(26,26,230,0.3)' }}
          >
            {loading ? 'Création en cours...' : 'Créer le projet →'}
          </button>
        </form>
      </div>
    </div>
  );
}

function DashboardAdmin() {
  const [user, setUser] = useState(null);
  const [projets, setProjets] = useState([]);
  const [devis, setDevis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onglet, setOnglet] = useState('overview');
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (!userData || !token) {
      navigate('/login');
      return;
    }

    const u = JSON.parse(userData);
    if (u.role !== 'admin') {
      navigate('/dashboard/client');
      return;
    }

    setUser(u);
    chargerDonnees(token);
  }, [navigate]);

  const chargerDonnees = async (token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const [projetsRes, devisRes] = await Promise.all([
        axios.get('https://efe-systems.com/api/projets', { headers }),
        axios.get('https://efe-systems.com/api/devis', { headers }),
      ]);

      const projetsData = projetsRes.data.data || projetsRes.data;
      const devisData = devisRes.data.data || devisRes.data;

      setProjets(Array.isArray(projetsData) ? projetsData : []);
      setDevis(Array.isArray(devisData) ? devisData : []);
    } catch (error) {
      console.error('Erreur:', error);
      setProjets([]);
      setDevis([]);
    } finally {
      setLoading(false);
    }
  };

  const deconnexion = async () => {
    const token = localStorage.getItem('token');
    try {
      await axios.post('https://efe-systems.com/api/logout', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (e) {}
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const statutConfig = {
    'en_attente':  { label: 'En attente',   couleur: '#F5C500', bg: 'rgba(245,197,0,0.1)',    icone: '⏳' },
    'en_cours':    { label: 'En cours',      couleur: '#1A1AE6', bg: 'rgba(26,26,230,0.1)',    icone: '🔄' },
    'phase_test':  { label: 'Phase test',    couleur: '#6B21E8', bg: 'rgba(107,33,232,0.1)',   icone: '🧪' },
    'en_revision': { label: 'En révision',   couleur: '#0EA5E9', bg: 'rgba(14,165,233,0.1)',   icone: '✏️' },
    'livre':       { label: 'Livré',         couleur: '#10B981', bg: 'rgba(16,185,129,0.1)',   icone: '✅' },
    'archive':     { label: 'Archivé',       couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)',  icone: '📦' },
  };

  const devisStatutConfig = {
    'nouveau':       { label: 'Nouveau',        couleur: '#F5C500', bg: 'rgba(245,197,0,0.1)',   icone: '🔔' },
    'en_analyse':    { label: 'En analyse',     couleur: '#1A1AE6', bg: 'rgba(26,26,230,0.1)',   icone: '🔍' },
    'devis_envoye':  { label: 'Devis envoyé',   couleur: '#6B21E8', bg: 'rgba(107,33,232,0.1)', icone: '📤' },
    'accepte':       { label: 'Accepté',        couleur: '#10B981', bg: 'rgba(16,185,129,0.1)', icone: '✅' },
    'refuse':        { label: 'Refusé',         couleur: '#EF4444', bg: 'rgba(239,68,68,0.1)',  icone: '❌' },
    'annule':        { label: 'Annulé',         couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)',icone: '🚫' },
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#f8f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="text-center">
          <div className="text-4xl mb-4">⚡</div>
          <p style={{ color: '#1A1AE6', fontWeight: '600' }}>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9ff' }}>
      <Navbar />

      {/* Header sombre */}
      <div style={{ background: '#050510', paddingTop: '80px' }}>
        <div className="max-w-7xl mx-auto px-6 py-10">
          <div className="flex items-center justify-between mb-8">
            <div>
              <p className="text-gray-400 text-sm mb-1">Administration</p>
              <h1 className="text-3xl font-extrabold text-white">
                Dashboard <span style={{ color: '#F5C500' }}>Admin</span> ⚡
              </h1>
              <p className="text-gray-400 mt-1 text-sm">Bienvenue {user?.prenom} — Vue globale EFE Systems</p>
            </div>
            <button
              onClick={deconnexion}
              className="px-4 py-2 rounded-xl text-sm font-semibold transition hover:opacity-80"
              style={{ background: 'rgba(239,68,68,0.15)', color: '#EF4444', border: '1px solid rgba(239,68,68,0.3)' }}
            >
              Déconnexion
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: 'Projets total',  valeur: projets.length,                                         icone: '📁', couleur: '#1A1AE6' },
              { label: 'Devis reçus',    valeur: devis.length,                                           icone: '📋', couleur: '#F5C500' },
              { label: 'Projets livrés', valeur: projets.filter(p => p.statut === 'livre').length,       icone: '✅', couleur: '#10B981' },
              { label: 'Devis nouveaux', valeur: devis.filter(d => d.statut === 'nouveau').length,       icone: '🔔', couleur: '#EF4444' },
            ].map((stat, i) => (
              <div key={i} className="rounded-2xl p-4 text-center"
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="text-2xl mb-1">{stat.icone}</div>
                <p className="text-2xl font-extrabold" style={{ color: stat.couleur }}>{stat.valeur}</p>
                <p className="text-gray-400 text-xs mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="max-w-7xl mx-auto px-6 py-10">

        {/* Onglets */}
        <div className="flex gap-2 mb-8 flex-wrap">
          {[
            { id: 'overview',     label: '📊 Vue globale' },
            { id: 'projets',      label: '📁 Projets' },
            { id: 'devis',        label: '📋 Devis' },
            { id: 'contacts',     label: '💬 Contacts' },
            { id: 'creer-compte', label: '👤 Créer un compte' },
            { id: 'creer-projet', label: '➕ Créer un projet' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setOnglet(tab.id)}
              className="px-5 py-2 rounded-xl text-sm font-semibold transition"
              style={{
                background: onglet === tab.id ? '#1A1AE6' : 'white',
                color: onglet === tab.id ? 'white' : '#6B7280',
                border: `1px solid ${onglet === tab.id ? '#1A1AE6' : 'rgba(0,0,0,0.08)'}`,
                boxShadow: onglet === tab.id ? '0 4px 15px rgba(26,26,230,0.3)' : 'none',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Vue globale */}
        {onglet === 'overview' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="rounded-2xl p-6 bg-white"
              style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
              <h3 className="font-bold text-lg mb-4" style={{ color: '#0F0F2D' }}>📁 Derniers projets</h3>
              {projets.length === 0 ? (
                <p className="text-gray-400 text-sm">Aucun projet pour le moment</p>
              ) : (
                projets.slice(0, 5).map((projet, i) => {
                  const statut = statutConfig[projet.statut] || { label: projet.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                  return (
                    <div key={i} className="flex items-center justify-between py-3"
                      style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <div>
                        <p className="font-medium text-sm" style={{ color: '#0F0F2D' }}>{projet.titre}</p>
                        <p className="text-gray-400 text-xs">{projet.client?.prenom} {projet.client?.nom}</p>
                      </div>
                      <span className="px-2 py-1 rounded-full text-xs font-bold flex items-center gap-1"
                        style={{ background: statut.bg, color: statut.couleur }}>
                        {statut.icone} {statut.label}
                      </span>
                    </div>
                  );
                })
              )}
            </div>

            <div className="rounded-2xl p-6 bg-white"
              style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
              <h3 className="font-bold text-lg mb-4" style={{ color: '#0F0F2D' }}>📋 Derniers devis</h3>
              {devis.length === 0 ? (
                <p className="text-gray-400 text-sm">Aucun devis pour le moment</p>
              ) : (
                devis.slice(0, 5).map((d, i) => {
                  const statut = devisStatutConfig[d.statut] || { label: d.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                  return (
                    <div key={i} className="flex items-center justify-between py-3"
                      style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <div>
                        <p className="font-medium text-sm" style={{ color: '#0F0F2D' }}>{d.nom_contact}</p>
                        <p className="text-gray-400 text-xs">{d.titre_projet}</p>
                      </div>
                      <span className="px-2 py-1 rounded-full text-xs font-bold flex items-center gap-1"
                        style={{ background: statut.bg, color: statut.couleur }}>
                        {statut.icone} {statut.label}
                      </span>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        )}

        {/* Projets */}
        {onglet === 'projets' && (
          <div className="flex flex-col gap-4">
            {projets.length === 0 ? (
              <div className="text-center py-20 rounded-3xl bg-white"
                style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
                <p className="text-5xl mb-4">📁</p>
                <p className="font-bold text-xl" style={{ color: '#0F0F2D' }}>Aucun projet pour le moment</p>
              </div>
            ) : (
              projets.map((projet, index) => {
                const statut = statutConfig[projet.statut] || { label: projet.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                return (
                  <div key={index} className="rounded-2xl bg-white overflow-hidden transition hover:shadow-lg"
                    style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
                    <div className="h-1.5 w-full" style={{ background: statut.couleur }}></div>
                    <div className="p-6">
                      <div className="flex items-start justify-between mb-4">
                        <div>
                          <h3 className="font-extrabold text-xl mb-1" style={{ color: '#0F0F2D' }}>{projet.titre}</h3>
                          <p className="text-gray-400 text-sm mb-1">{projet.description}</p>
                          <p className="text-gray-400 text-xs">
                            👤 {projet.client?.prenom} {projet.client?.nom} — {projet.client?.email}
                          </p>
                        </div>
                        <span className="px-3 py-1.5 rounded-full text-xs font-bold flex-shrink-0 ml-4 flex items-center gap-1"
                          style={{ background: statut.bg, color: statut.couleur }}>
                          {statut.icone} {statut.label}
                        </span>
                      </div>
                      <div className="mb-4">
                        <div className="flex justify-between text-xs mb-1.5" style={{ color: '#6B7280' }}>
                          <span>Progression</span>
                          <span className="font-bold" style={{ color: statut.couleur }}>{projet.progression || 0}%</span>
                        </div>
                        <div className="rounded-full h-3" style={{ background: '#f0f0f0' }}>
                          <div className="h-3 rounded-full transition-all duration-500"
                            style={{ width: `${projet.progression || 0}%`, background: statut.couleur }}>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-4 text-xs" style={{ color: '#9CA3AF' }}>
                        {projet.date_debut && <span>📅 {new Date(projet.date_debut).toLocaleDateString('fr-FR')}</span>}
                        {projet.date_livraison_prevue && <span>🎯 {new Date(projet.date_livraison_prevue).toLocaleDateString('fr-FR')}</span>}
                        {projet.montant_total && <span>💰 {projet.montant_total} $</span>}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* Devis */}
        {onglet === 'devis' && (
          <div className="flex flex-col gap-4">
            {devis.length === 0 ? (
              <div className="text-center py-20 rounded-3xl bg-white"
                style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
                <p className="text-5xl mb-4">📋</p>
                <p className="font-bold text-xl" style={{ color: '#0F0F2D' }}>Aucun devis pour le moment</p>
              </div>
            ) : (
              devis.map((d, index) => {
                const statut = devisStatutConfig[d.statut] || { label: d.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                return (
                  <div key={index} className="rounded-2xl bg-white overflow-hidden transition hover:shadow-lg"
                    style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
                    <div className="h-1.5 w-full" style={{ background: statut.couleur }}></div>
                    <div className="p-6">
                      <div className="flex items-start justify-between mb-3">
                        <div>
                          <h3 className="font-extrabold text-xl mb-1" style={{ color: '#0F0F2D' }}>{d.titre_projet}</h3>
                          <p className="text-gray-500 text-sm">👤 {d.nom_contact} — {d.email_contact}</p>
                          {d.telephone_contact && <p className="text-gray-400 text-xs">📱 {d.telephone_contact}</p>}
                          {d.entreprise_contact && <p className="text-gray-400 text-xs">🏢 {d.entreprise_contact}</p>}
                        </div>
                        <span className="px-3 py-1.5 rounded-full text-xs font-bold flex-shrink-0 ml-4 flex items-center gap-1"
                          style={{ background: statut.bg, color: statut.couleur }}>
                          {statut.icone} {statut.label}
                        </span>
                      </div>
                      <p className="text-gray-400 text-sm mb-3">{d.description_projet}</p>
                      <div className="flex flex-wrap gap-2 mb-3">
                        {d.services_demandes && d.services_demandes.map((s, i) => (
                          <span key={i} className="px-3 py-1 rounded-full text-xs font-medium"
                            style={{ background: 'rgba(26,26,230,0.08)', color: '#1A1AE6', border: '1px solid rgba(26,26,230,0.15)' }}>
                            {s}
                          </span>
                        ))}
                      </div>
                      <div className="flex flex-wrap gap-4 text-xs" style={{ color: '#9CA3AF' }}>
                        <span>💰 {d.budget_estime}</span>
                        {d.deadline_souhaitee && <span>📅 {new Date(d.deadline_souhaitee).toLocaleDateString('fr-FR')}</span>}
                        <span>🕐 {new Date(d.created_at).toLocaleDateString('fr-FR')}</span>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* Contacts */}
        {onglet === 'contacts' && (
          <div className="text-center py-20 rounded-3xl bg-white"
            style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
            <p className="text-5xl mb-4">💬</p>
            <p className="font-bold text-xl mb-2" style={{ color: '#0F0F2D' }}>Messages de contact</p>
            <p className="text-gray-400 text-sm">À venir prochainement.</p>
          </div>
        )}

        {/* Créer un compte */}
        {onglet === 'creer-compte' && <CreerCompte />}

      </div>

      {/* Créer un projet */}
{onglet === 'creer-projet' && <CreerProjet />}

      <Footer />
    </div>
  );
}

export default DashboardAdmin;